import {
  arrayOf,
  params,
  string,
} from '@thd-nucleus/data-sources';
import { productDetails } from './LifeStyleDataModel';

export const dynamicRecsDataModel = {
  recs: params({
    anchorId: string().isRequired(),
    apiName: string().isRequired()
  }).shape({
    products: arrayOf(productDetails)
  })
};